// RR\ID Resource Hub (issue #37 / Aug 19 sitting): the SoftR landing carries six hub links that
// AEs still use; staging home had none. Same labels, opening in new tabs. Training / Newsletters /
// FAQs still point at their legacy SoftR homes until Angel confirms refreshed targets (#37's
// "content refresh is the work") — swap the URLs here when she does.
import { Card, CardBody, CardHeader } from "../../components/ui.js";

const HUB_LINKS: { label: string; href: string; emoji: string }[] = [
  { label: "Website", href: "https://rrid.mitpress.mit.edu/", emoji: "🌐" },
  { label: "Training", href: "https://rrid.softr.app/achievement-and-training-dashboard", emoji: "🎓" },
  { label: "Newsletters", href: "https://rrid.softr.app/", emoji: "📰" },
  { label: "bCourses", href: "https://bcourses.berkeley.edu/", emoji: "📚" },
  { label: "PREreview", href: "https://prereview.org/", emoji: "🔬" },
  { label: "FAQs", href: "https://rrid.softr.app/help", emoji: "❓" },
];

export function ResourceHub(): JSX.Element {
  return (
    <Card>
      <CardHeader>
        <h3 className="text-sm font-semibold">RR\ID Resource Hub</h3>
      </CardHeader>
      <CardBody>
        <div className="flex flex-wrap gap-2">
          {HUB_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-1.5 rounded-md border border-slate-200 px-3 py-1.5 text-sm font-medium text-slate-700 transition hover:border-brand hover:text-brand hover:shadow-sm"
            >
              <span>{l.emoji}</span>
              {l.label} ↗
            </a>
          ))}
        </div>
      </CardBody>
    </Card>
  );
}
